export default {
  xs: '480px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
  xl: '1400px',
  '2xl': '1800px',
  '3xl': '2400px'
};
